<template>
   <div :class="sourceInputClass">
        <label class="input__label" for="canvasser-source-field" v-text="label"></label>

        <multiselect
            v-if="sources.length"
            v-model="source"
            track-by="id"
            id="canvasser-source-field"
            label="name"
            placeholder="Please select a channel"
            openDirection="below"
            :allow-empty="false"
            :options="sources"/>

        <!-- Validation -->
        <p class="input__message" v-if="showSourceRequiredValidationMessage"
           v-html="$t('SOURCE_FIELD_CHANNEL')">
        </p>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import required from 'vuelidate/src/validators/required';
import SourceService from '@/services/canvassers/SourceService';

let sourceService = new SourceService();

export default {
    name: 'SourcesField',
    props: {
        value: {
            default: null,
            type: Object,
        },
        label: {
            default: '',
            type: String,
        },
        parentId: {
            default: null,
            type: Number,
        },
    },
    data() {
        return {
            source: null,
            sources: [],
        };
    },
    computed: {
        sourceInputClass() {
            if (this.source === null) return 'input';

            return this.isSourceValid ? 'input input--success' : 'input input--invalid';
        },

        isSourceValid() {
            return !this.$v.source.$invalid;
        },

        showSourceRequiredValidationMessage() {
            return this.source !== null && !this.$v.source.required;
        },
    },
    mounted() {
        this.getSources();
    },
    methods: {
        /**
         * Get the canvasser sources.
         *
         * @returns {void}
         */
        getSources() {
            sourceService.getSources(this.parentId)
                .then(response => { this.sources = response.data.data; });
        },

        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$v.$touch();

            this.$emit('input', this.source);
        },

        /**
         * Update source from prop.
         *
         * @param {Object} value
         *
         * @returns {void}
         */
        updateSource(value) {
            this.source = value;
        },
    },
    validations: {
        source: {
            required,
        },
    },
    watch: {
        source() {
            this.updateInput();
        },
        value: {
            handler(newValue) {
                if (newValue !== this.source) {
                    this.updateSource(newValue);
                }
            },
            immediate: true,
        },
    },
    components: {
        Multiselect,
    },
};
</script>
